// extracted by mini-css-extract-plugin
export default {"main":"CSS_main__tIRo8"};